import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import VueRouter from 'vue-router';
import axios from 'axios'
import './plugins/bootstrap-vue'

import Sugar from 'sugar'
Sugar.extend()

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
  dsn: 'https://d2826f7b8f7e4cb4a54e132e35bde0d2@o411107.ingest.sentry.io/5285928',
  integrations: [new VueIntegration({Vue, attachProps: true, logErrors: true})],
});

//firebase
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyC0wdhVxFtx8RUSQ74cO9AnCn_z_AbR5K0",
  authDomain: "vo2-master-cloud.firebaseapp.com",
  projectId: "vo2-master-cloud",
  storageBucket: "vo2-master-cloud.appspot.com",
  messagingSenderId: "1031815280256",
  appId: "1:1031815280256:web:f39238ec65d5fcd3bd1865",
  measurementId: "G-DDTN57LPTL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// alias
Vue.prototype.$analytics = {
  logEvent: function(event_name) {
    logEvent(analytics, event_name)
  },
  screenView: function(screenName) {
    logEvent(analytics, 'screen_view', {
      firebase_screen: screenName,
      firebase_screen_class: ''
    });
  }
}


import Vuex from 'vuex'
Vue.use(Vuex)

//moment
Vue.use(require('vue-moment'));

//numerals
import VueNumerals from 'vue-numerals';
Vue.use(VueNumerals);

//chartkick
import './plugins/chartjs'

//good table
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
Vue.use(VueGoodTablePlugin);

//good wizard
import VueGoodWizard from 'vue-good-wizard';
Vue.use(VueGoodWizard);

//country select
import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect);

//font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(fas, far)
import { dom } from '@fortawesome/fontawesome-svg-core'
dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver

Vue.component('font-awesome-icon', FontAwesomeIcon)

//sidebar menu
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)

//Auth0
import { Auth0Plugin } from "./auth";


//App
import SessionHub from './plugins/session-hub'
import App from './App.vue'
import {store} from './store/index'


axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.timeout = 15000

Vue.prototype.$http = axios
Vue.config.productionTip = false

import router from './routes.js';


Vue.use(VueRouter);
Vue.use(SessionHub);
Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENTID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  onRedirectCallback: appState => {
    router.push(
        appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
    );
  }
});




new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
